import { useReducer } from 'react'
import effects from 'app/effects/effects'
import { forEach, reduce, map, prop, keys } from 'ramda'
import MessageAlert from 'app/components/MessageAlert'

export const tabIds = {
  profile: 'profile',
  account: 'account',
  membership: 'membership',
  activity: 'activity',
}

export const tabs = [
  { id: tabIds.profile, labelId: 'subscriberDetail.profile.tab' },
  { id: tabIds.account, labelId: 'subscriberDetail.account.tab' },
  // { id: tabIds.membership, labelId: 'subscriberDetail.membership.tab' },
  // { id: tabIds.activity, labelId: 'subscriberDetail.activity.tab' },
]

export const ActionType = {
  OPEN_GROUP_SELECTOR: 'OPEN_GROUP_SELECTOR',
  CLOSE_GROUP_SELECTOR: 'CLOSE_GROUP_SELECTOR',
  SET_GROUP_SELECTED: 'SET_GROUP_SELECTED',
  OPEN_TOPICS_SELECTOR: 'OPEN_TOPICS_SELECTOR',
  CLOSE_TOPICS_SELECTOR: 'CLOSE_TOPICS_SELECTOR',
  SET_TOPIOCS_SELECTED: 'SET_TOPIOCS_SELECTED',
  TOGGLE_TAB: 'TOGGLE_TAB',
  STATR_TOPIC_SUBMIT_LOADING: 'STATR_TOPIC_SUBMIT_LOADING',
  TOPIC_SUBMIT_ERROR: 'TOPIC_SUBMIT_ERROR',
  STATR_GROUP_SUBMIT_LOADING: 'STATR_GROUP_SUBMIT_LOADING',
  GROUP_SUBMIT_ERROR: 'GROUP_SUBMIT_ERROR',
  SET_DEFAULT_GROUP_ADN_TOPICS: 'SET_DEFAULT_GROUP_ADN_TOPICS',
}

const initialState = {
  tagSelected: [],
  isOpenGropSelector: false,
  topicsSelector: [],
  isOpenTopicsSelector: false,
  tab: tabIds.profile,
  isTopicSubmitting: false,
  isGroupSubmitting: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.OPEN_GROUP_SELECTOR:
      return {
        ...state,
        isOpenGropSelector: true,
        isGroupSubmitting: false,
      }
    case ActionType.CLOSE_GROUP_SELECTOR:
      return {
        ...state,
        isOpenGropSelector: false,
      }
    case ActionType.SET_GROUP_SELECTED:
      return {
        ...state,
        tagSelected: action.payload.selectedTags,
        isGroupSubmitting: true,
        isOpenGropSelector: false,
      }
    case ActionType.OPEN_TOPICS_SELECTOR:
      return {
        ...state,
        isOpenTopicsSelector: true,
        isTopicSubmitting: false,
      }
    case ActionType.CLOSE_TOPICS_SELECTOR:
      return {
        ...state,
        isOpenTopicsSelector: false,
      }
    case ActionType.SET_TOPIOCS_SELECTED:
      return {
        ...state,
        topicsSelector: action.payload,
        isTopicSubmitting: true,
        isOpenTopicsSelector: false,
      }

    case ActionType.TOGGLE_TAB:
      return {
        ...state,
        tab: action.payload,
      }

    case ActionType.STATR_TOPIC_SUBMIT_LOADING:
      return {
        ...state,
        isTopicSubmitting: true,
      }
    case ActionType.TOPIC_SUBMIT_ERROR:
      return {
        ...state,
        isTopicSubmitting: false,
      }
    case ActionType.STATR_GROUP_SUBMIT_LOADING:
      return {
        ...state,
        isGroupSubmitting: true,
      }
    case ActionType.GROUP_SUBMIT_ERROR:
      return {
        ...state,
        isGroupSubmitting: false,
      }

    case ActionType.SET_DEFAULT_GROUP_ADN_TOPICS:
      return {
        ...state,
        tagSelected: action.payload.tagSelected,
        topicsSelector: action.payload.topicIds,
      }

    default:
      return state
  }
}

export default function useQuickInfo({ commonDispatch, formatMessage }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  const onOpenGroupSelector = () => {
    dispatch({ type: ActionType.OPEN_GROUP_SELECTOR })
  }
  const onCloseGroupSelector = () => {
    dispatch({ type: ActionType.CLOSE_GROUP_SELECTOR })
  }

  const onGroupSelectorConfirm = ({ subscriberId, groups }) => {
    dispatch({ type: ActionType.STATR_GROUP_SUBMIT_LOADING })
    effects.apis
      .attachGroupToSubscriber({ subscriberId, tagIds: groups.selectedTags })
      .then(() => {
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'message.alert.success' }),
          }),
        )
        setTimeout(() => {
          dispatch({ type: ActionType.SET_GROUP_SELECTED, payload: groups })
        }, 1000)
      })
      .catch(() => {
        dispatch({
          type: ActionType.GROUP_SUBMIT_ERROR,
        })
        commonDispatch(
          MessageAlert.showError({
            message: formatMessage({ id: 'message.alert.error' }),
          }),
        )
      })
  }

  const onSetGroupSelected = (groups) => {
    const mapState = reduce(
      (acc, item) => {
        const tagsId = item.tags.map((tag) => {
          return tag.id
        })
        if (tagsId.length > 0) {
          acc.push(...tagsId)
        }

        return acc
      },
      [],
      groups,
    )
    dispatch({ type: ActionType.SET_GROUP_SELECTED, payload: mapState })
  }

  const onOpenTopicsSelector = () => {
    dispatch({ type: ActionType.OPEN_TOPICS_SELECTOR })
  }
  const onCloseTopicsSelector = () => {
    dispatch({ type: ActionType.CLOSE_TOPICS_SELECTOR })
  }

  const onTopicsSelectorConfirm = ({ subscriberId, topicIds }) => {
    dispatch({ type: ActionType.STATR_TOPIC_SUBMIT_LOADING })
    effects.apis
      .attachTopicToSubscriber({ subscriberId, topicIds })
      .then((response) => {
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'message.alert.success' }),
          }),
        )
        setTimeout(() => {
          dispatch({ type: ActionType.SET_TOPIOCS_SELECTED, payload: topicIds })
        }, 1000)
      })
      .catch((error) => {
        dispatch({
          type: ActionType.TOPIC_SUBMIT_ERROR,
        })
        commonDispatch(
          MessageAlert.showError({
            message: formatMessage({ id: 'message.alert.error' }),
          }),
        )
      })
  }

  const toggleTab = (tab, newValue) => {
    dispatch({ type: ActionType.TOGGLE_TAB, payload: newValue })
  }

  const onSetDefaultGroupAndTopics = (subscriber) => {
    const topicIds = map(prop('id'), subscriber.topics)
    let tagSelected = []

    forEach((group) => {
      tagSelected.push(...map(prop('id'), group.tags))
    }, subscriber.groups)

    dispatch({
      type: ActionType.SET_DEFAULT_GROUP_ADN_TOPICS,
      payload: { tagSelected, topicIds },
    })
  }

  return {
    state,
    onOpenGroupSelector,
    onCloseGroupSelector,
    onGroupSelectorConfirm,
    onSetGroupSelected,
    onOpenTopicsSelector,
    onCloseTopicsSelector,
    onTopicsSelectorConfirm,
    toggleTab,
    onSetDefaultGroupAndTopics,
  }
}
